import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Form as FinalForm } from 'react-final-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { map, path } from 'ramda';

import {
  ModalSwimmy,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from '../../components/ModalSwimmy';
import css from './CompleteListingDataModal.css';
import { FieldBoolean, FieldSelect, Form, PrimaryButton } from '../index';
import { required } from '../../util/validators';
import { getOverLookedEditListing } from '../../marketplace-custom-config';
import { requestUpdateListing } from '../../containers/EditListingPage/EditListingPage.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import CompleteListingDataModalOverLookForm from './forms/CompleteListingDataModal.OverlookForm';
import AskMinTotalAmountPerBookingForm from './forms/AskMinTotalAmountPerBookingForm';

const CompleteListingDataModal = (props) => {
  const {
    onUpdateListing,
    updateInProgress,
    updateListingError,
    listingId,
    listing,
    intl,
    currentUserHasListings,
    onManageDisableScrolling,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const hasListingData = !!listing;

  const overLookedMaybe = path(['attributes', 'publicData', 'overLooked'], listing);
  // Temporarily disabled: minTotalAmountPerBooking step.
  // const minTotalAmountPerBooking = path(['attributes', 'publicData', 'minTotalAmountPerBooking'], listing);
  // const repliedForMinTotalAmountPerBooking = path(['attributes', 'privateData', 'repliedForMinTotalAmountPerBooking'], listing) || minTotalAmountPerBooking;
  // const canShowMinTotalAmountPerBooking = !repliedForMinTotalAmountPerBooking;
  const canShowMinTotalAmountPerBooking = false;
  const canShowOverlookForm = !overLookedMaybe;
  const hasFilledForm = !canShowOverlookForm && !canShowMinTotalAmountPerBooking;

  useEffect(() => {
    if (isOpen || !currentUserHasListings || !listingId || !hasListingData || hasFilledForm) {
      setIsOpen(false);
      return;
    }

    setIsOpen(true);
  }, [currentUserHasListings, hasListingData, hasFilledForm]);

  return (
    <ModalSwimmy
      id="CompleteListingDataModal"
      isOpen={isOpen}
      onClose={() => setIsOpen(true)}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <ModalOverlay />
      {canShowMinTotalAmountPerBooking ? (
        <AskMinTotalAmountPerBookingForm
          intl={intl}
          listingId={listingId}
          onUpdateListing={onUpdateListing}
          updateInProgress={updateInProgress}
          updateListingError={updateListingError}
        />
      ) : (
        <CompleteListingDataModalOverLookForm
          intl={intl}
          listingId={listingId}
          onUpdateListing={onUpdateListing}
          updateInProgress={updateInProgress}
          updateListingError={updateListingError}
        />
      )}
    </ModalSwimmy>
  );
};

CompleteListingDataModal.propTypes = {
  onCompleteListingDataModalClose: func.isRequired,
  onManageDisableScrolling: func,
  intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
  const getOwnListing = (id) => {
    const listings = getMarketplaceEntities(state, [{ id, type: 'ownListing' }]);

    return listings.length === 1 ? listings[0] : null;
  };
  const { updateInProgress, updateListingError } = state.EditListingPage;
  const listingId = path(['user', 'currentUserListingRefs', 0, 'id'], state);
  const listing = getOwnListing(listingId);

  return {
    updateInProgress,
    updateListingError,
    listingId: listingId?.uuid,
    listing,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onUpdateListing: (tab, values) => dispatch(requestUpdateListing(tab, values)),
});

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(CompleteListingDataModal);
